// import { SEO } from "../../../seo/keywords";

export default function DeepDiveRobotic() {
    return (
        <div className="relative flex flex-row w-full h-full items-center justify-center bg-[#4153C5] pb-[5rem]">
            {/* absolute and no percentage for top will help you stablize the block. */}
            <div className="absolute top-[-3.6rem] flex flex-col items-center justify-center w-[70%] h-[8rem] bg-[#00B1F5] text-[1.5rem] md:text-[2.2rem] font-bold text-center border-[0.5rem] border-[#00B1F5] rounded-2xl">
                <h2 id="deep-dive-robotics" className="text-white leading-tight">
                    A Deep Dive into <span className="text-[#FDF16C]">Education Robotics</span>
                </h2>
            </div>
            
            <div className="flex items-center justify-center text-center h-[90%] w-[90%] border-[0.5rem] border-[#00B1F5] rounded-2xl bg-[#FFFFFF]">
                <ol className="flex flex-col m-[10rem] 2xl:flex-row gap-y-[10rem] 2xl:gap-x-[10rem] items-center justify-center w-full text-[2rem] font-bold text-center">
                    <li className="flex flex-col xl:flex-row 2xl:flex-col xl:w-[40%] 2xl:w-[24%] h-full items-center justify-center gap-x-[5rem] 2xl:gap-y-[1rem]">
                        <p className="flex flex-row gap-x-[0.5rem]">
                            <span className="text-[#2FC1E2]">1.</span>
                            <span>Learn About Electronics</span>
                        </p>
                        <img
                            src="./pictures/decor_image1.webp"
                            className="w-56 h-40"
                            alt="Electronics fundamentals for students robotics projects"
                        />
                    </li>

                    <li className="flex flex-col xl:flex-row 2xl:flex-col xl:w-[40%] 2xl:w-[24%] h-full items-center justify-center gap-x-[5rem] 2xl:gap-y-[1rem]">
                        <p className="flex flex-row gap-x-[0.5rem]">
                            <span className="text-[#2FC1E2]">2.</span>
                            <span>Learn About Programming</span>
                        </p>
                        <img
                            src="./pictures/decor_image2.webp"
                            className="w-56 h-40"
                            alt="Programming basics in a beginner robotics course"
                        />
                    </li>

                    <li className="flex flex-col xl:flex-row 2xl:flex-col xl:w-[40%] 2xl:w-[24%] h-full items-center justify-center gap-x-[5rem] 2xl:gap-y-[1rem]">
                        <p className="flex flex-row gap-x-[0.5rem]">
                            <span className="text-[#2FC1E2]">3.</span>
                            <span>Build a Robot</span>
                        </p>
                        <img
                            src="./pictures/decor_image3.webp"
                            className="w-44 h-38"
                            alt="Build a robot with an engineering kit designed for robotics for classrooms"
                        />
                    </li>
                </ol>
            </div>
        </div>
    )
}